import React, { useContext } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { LayoutContext } from "App/common/hoc/Layout";
import Loader from "App/common/ui/Loader";
import Volumes from "./volumes";
import { decodeHandler, sortArray } from "utils";
import {
  initiateStopRestore,
  initiatePauseBackup,
  initiateResumeBackup,
  initiateStopBackup
} from "store/actions";

function SlidingPopupContent(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const { sPopupMethods } = useContext(SPopupContext);
  const progress = props.clients[lState.slidingPopup.params.clientUUID]
    .restoreStatus
    ? props.clients[lState.slidingPopup.params.clientUUID].restoreStatus
    : props.clients[lState.slidingPopup.params.clientUUID].status.progress;
  const isRestoreInProgress =
    props.clients[lState.slidingPopup.params.clientUUID].restoreStatus;
  const detailedProgress = progress.diskInfo;
  const machineStatus =
    props.clients[lState.slidingPopup.params.clientUUID].machineStatus;
  const status = props.clients[lState.slidingPopup.params.clientUUID]
    .restoreStatus
    ? props.enums.RestoreStatus.props[
        props.clients[lState.slidingPopup.params.clientUUID].restoreStatus
          .status
      ].key
    : props.enums.BackupScheduleStatus.props[
        props.clients[lState.slidingPopup.params.clientUUID].status.value
      ].key;

  if (
    progress.completed ||
    progress.failed ||
    status === "CANCELLED" ||
    status === "PAUSED" ||
    machineStatus === "offline"
  ) {
    const timer = setTimeout(() => {
      lMethods.closeSlidingPopup();
      clearTimeout(timer);
    }, 1000);
  }

  return (
    <div
      className={[
        "slider_view_list slider_view_list_progress",
        !detailedProgress ? "is_relative" : null,
        props.clients[lState.slidingPopup.params.clientUUID].restoreStatus
          ? "slider_restore_progress"
          : null
      ].join(" ")}
    >
      {detailedProgress ? (
        <>
          <div className="slider_view_list__inner">
            <div className="slider_view_list_title">
              <div className="sub_title" style={{ marginBottom: "10px" }}>
                {"View progress of the " +
                  (props.clients[lState.slidingPopup.params.clientUUID]
                    .restoreStatus
                    ? "restore"
                    : "backup")}
              </div>
            </div>
            <div className="slider_view_list__body">
              <div className="view_list_logs_wrap__body">
                {Object.keys(detailedProgress).map((disk, i) => (
                  <div className={"vll_item vll_item_" + (i + 1)} key={i}>
                    <div className="vll_item__head flex_align">
                      <div className="vll_item__head__icon" />
                      <div className="vll_item__head__name">{disk}</div>
                    </div>
                    <div className="vll_item__content">
                      {sortArray(detailedProgress[disk], "drive").map(
                        (vol, k) => {
                          const volStatusKey = props.clients[
                            lState.slidingPopup.params.clientUUID
                          ].restoreStatus
                            ? props.enums.RestoreStatus.props[vol.status].key
                            : props.enums.BackupScheduleStatus.props[vol.status]
                                .key;

                          return (
                            <Volumes
                              volume={vol}
                              key={k}
                              k={k}
                              volStatusKey={volStatusKey}
                              type={
                                props.clients[
                                  lState.slidingPopup.params.clientUUID
                                ].restoreStatus
                                  ? "restore"
                                  : "backup"
                              }
                              pausedStatus={progress.pausedStatus}
                            />
                          );
                        }
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {!isRestoreInProgress && progress ? (
            <div className="slider_view_list__footer">
              <div className="slider_summary_btns">
                <div className="slider_summary_btns__inner">
                  <div className="backup_image_btns just_flex">
                    <div
                      className={`slider_btn btn_primary ${
                        !progress.pausedStatus ? "btn_pause" : "btn_resume"
                      }`}
                      onClick={() => {
                        if (!progress.pausedStatus) {
                          sPopupMethods.openPopup("pauseBackup", {
                            body: {
                              CLIENT_NAME: decodeHandler(
                                props.clients[
                                  lState.slidingPopup.params.clientUUID
                                ].name
                              )
                            },
                            execute: () => {
                              props.initiatePauseBackup(
                                lState.slidingPopup.params.clientUUID
                              );
                              sPopupMethods.closePopup();
                            }
                          });
                        } else
                          props.initiateResumeBackup(
                            lState.slidingPopup.params.clientUUID
                          );
                      }}
                    >
                      {!progress.pausedStatus
                        ? "Pause Backup"
                        : "Resume Backup"}
                    </div>
                    <div
                      className={"slider_btn btn_cancel remove_machine_btn"}
                      onClick={() => {
                        sPopupMethods.openPopup("cancelBackup", {
                          body: {
                            CLIENT_NAME: decodeHandler(
                              props.clients[
                                lState.slidingPopup.params.clientUUID
                              ].name
                            )
                          },
                          execute: () => {
                            props.initiateStopBackup(
                              lState.slidingPopup.params.clientUUID
                            );
                            sPopupMethods.closePopup();
                            lMethods.closeSlidingPopup();
                          }
                        });
                      }}
                    >
                      Cancel Backup
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : props.clients[lState.slidingPopup.params.clientUUID]
              .restoreStatus ? (
            <div className="slider_view_list__footer">
              <div className="slider_summary_btns">
                <div className="slider_summary_btns__inner">
                  <div className="backup_image_btns just_flex">
                    <div
                      className={"slider_btn slider_btn_delete"}
                      onClick={() => {
                        sPopupMethods.openPopup("cancelRestore", {
                          body: {
                            CLIENT_NAME: decodeHandler(
                              props.clients[
                                lState.slidingPopup.params.clientUUID
                              ].name
                            )
                          },
                          execute: () => {
                            props.initiateStopRestore(
                              lState.slidingPopup.params.clientUUID
                            );
                            sPopupMethods.closePopup();
                            lMethods.closeSlidingPopup();
                          }
                        });
                      }}
                    >
                      Stop Restore
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients.list,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      initiateStopRestore,
      initiatePauseBackup,
      initiateResumeBackup,
      initiateStopBackup
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlidingPopupContent);
